import { createRouter, createWebHistory } from 'vue-router'
import JoinUs from '../views/JoinUs.vue'
import Activate from '../views/ActivatePage.vue'
import Rental from '../views/rental.vue'

// Task management system (isolated)
import TasksApp from '../views/tasks/TasksApp.vue'
import TasksLogin from '../views/tasks/TasksLogin.vue'
import TasksReset from '../views/tasks/TasksReset.vue'
import TasksDashboard from '../views/tasks/TasksDashboard.vue'
import TasksProjects from '../views/tasks/TasksProjects.vue'
import TasksProject from '../views/tasks/TasksProject.vue'
import TasksAll from '../views/tasks/TasksAll.vue'

const routes = [
  {
    path: '/',
    name: 'JoinUs',
    component: JoinUs
  },
  {
    path: '/activate',
    name: 'activate',
    component: Activate
  },
  {
    path: '/rental',
    name: 'rental',
    component: Rental
  },
  {
    path: '/tasks',
    component: TasksApp,
    children: [
      { path: '', name: 'tasks-dashboard', component: TasksDashboard },
      { path: 'login', name: 'tasks-login', component: TasksLogin },
      { path: 'reset', name: 'tasks-reset', component: TasksReset },
      { path: 'projects', name: 'tasks-projects', component: TasksProjects },
      { path: 'project/:id', name: 'tasks-project', component: TasksProject },
      { path: 'all', name: 'tasks-all', component: TasksAll },
      { path: 'mine', name: 'tasks-mine', component: TasksAll, props: { mineOnly: true } },
    ],
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  base: process.env.BASE_URL,
  routes
})

export default router
